import { Component, inject, NgZone, OnInit } from '@angular/core';
import { ActiveToast } from 'ngx-toastr';
import { ServerVersionService } from './server-version.service';
import { firstValueFrom } from 'rxjs';
import { TranslationService } from './common';
import { NotificationService } from './common/service/notification.service';

@Component({ selector: 'version-reload', template: '' })
export class VersionReloadComponent implements OnInit {
  private readonly server = inject(ServerVersionService);
  private readonly zone = inject(NgZone);
  private readonly toastr = inject(NotificationService);
  private readonly translate = inject(TranslationService);

  version: { server?: string; client: string } = { client: '' };
  alert?: ActiveToast<any>;

  ngOnInit(): void {
    this.server.subscribe(async (version) => {
      this.version = version;
      if (
        window.location.hostname !== 'localhost' &&
        version.server &&
        !version.server.endsWith('-dirty') &&
        !version.client.endsWith('-dirty') &&
        version.server != version.client &&
        !this.alert
      ) {
        const message = 'attention_new_app_version_tr';
        this.alert = await this.toastr.warning(message);
        await firstValueFrom(this.alert.onTap);
        this.alert = undefined;
        this.zone.runOutsideAngular(() => location.reload());
      }
    });
  }
}
